import type { Command } from "../types/command.types";

type CommandMaterialType = "SILICONE" | "RESIN";

type CommandMaterialContext = {
	leftMaterial: CommandMaterialType | null;
	rightMaterial: CommandMaterialType | null;
	material: CommandMaterialType | null;
	canInjectSilicone: boolean;
};

const getMaterialFromOption = (
	option: { label?: string } | null | undefined,
): CommandMaterialType | null => {
	if (!option?.label) return null;
	return option.label.includes("Résine") ? "RESIN" : "SILICONE";
};

export const getCommandMaterialLabel = (
	material: CommandMaterialType | null | undefined,
) => {
	if (material === "SILICONE") return "Silicone";
	if (material === "RESIN") return "Résine";
	return null;
};

const getCommandSideMaterial = (
	command: Pick<Command, "draft">,
	side: "left" | "right",
): CommandMaterialType | null => {
	const draft = command.draft;
	if (!draft) return null;
	const hasSide = side === "right" ? draft.hasRightEar : draft.hasLeftEar;
	if (!hasSide) return null;
	const variants = draft.variants;
	if (!Array.isArray(variants) || variants.length === 0) return null;
	const materialVariant = variants.find((variant) =>
		variant.label.startsWith("Matière"),
	);
	if (!materialVariant) return null;
	const form = side === "right" ? draft.rightEarForm : draft.leftEarForm;
	return getMaterialFromOption(form?.[materialVariant.id]);
};

export const getCommandMaterialContext = (
	command: Pick<Command, "draft" | "material">,
): CommandMaterialContext => {
	const leftMaterial = getCommandSideMaterial(command, "left");
	const rightMaterial = getCommandSideMaterial(command, "right");
	let material: CommandMaterialType | null = command.material ?? null;
	if (material === null) {
		if (leftMaterial === null) {
			material = rightMaterial ?? null;
		} else if (rightMaterial === null) {
			material = leftMaterial ?? null;
		} else {
			material = leftMaterial === rightMaterial ? leftMaterial : null;
		}
	}
	return {
		leftMaterial,
		rightMaterial,
		material,
		canInjectSilicone:
			leftMaterial === "SILICONE" ||
			rightMaterial === "SILICONE" ||
			command.material === "SILICONE",
	};
};
